import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import {
  Input,
  Button,
  Dialog,
  Checkbox,
  Dropdown,
  DropdownOption,
  ThreeStateValue,
  Icon,
} from "@abb/abb-common-ux-react";

import SubmitHeader from "../shared/SubmitHeader";

import history from "../../utilities/History";
import instrumentFormStore from "../../flux/stores/instrument/FormState";

import IInstrumentFormData, {
  InstrumentFormData,
} from "../../models/instrument/InstrumentFormData";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";

import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";

import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";
import IFormComponent from "../../models/shared/FormComponent";
import ConnectFormData, {
  IConnectFormData,
} from "../../models/device/ConnectFormData";

import deviceGuidStore from "../../flux/stores/device/GuidStore";
import connectDeviceStore from "../../flux/stores/device/ConnectDevice";
import encryption from "../../utilities/Encryption";

import "./instrument.sass";
import connectionActions from "../../flux/actions/ConnectionActions";
import fetchDataStore from "../../flux/stores/device/FetchDataStore";
import directionActions from "../../flux/actions/DirectionAction";
import directionListStore from "../../flux/stores/direction/ListStore";
import instrumentTypeActions from "../../flux/actions/InstrumentTypeActions";
import instrumentTypeListStore from "../../flux/stores/instrumentType/ListStore";
import instrumentCheckDuplicateIpStore from "../../flux/stores/instrument/CheckDuplicateIPStore";
import instrumentTypeByIdStore from "../../flux/stores/instrumentType/ByIdStore";
import getPropertyStore from "../../flux/stores/instrument/GetPropertyStore";
import checkPropertyInUseStore from "../../flux/stores/instrument/CheckPropertyInUseStore";
import instrumentActions from "../../flux/actions/InstrumentActions";
import {
  IInstrumentProperty,
  InstrumentProperty,
} from "../../models/instrument/InstrumentPropertyData";
import triggerNotifications from "../../utilities/TriggerNotifications";
import { ManualProperties } from "./ManualProperties";
import { BrowseProperty } from "./BrowseProperty";
import { IPropertyViewData } from "../../models/property/PropertyViewData";
import InstrumentTypeViewData, {
  IInstrumentTypeViewData,
  defaultInstrumentTypeData,
} from "../../models/instrumentType/InstrumentTypeViewData";
import IDeviceFetchViewData, {
  defaultDeviceFetchViewData,
} from "../../models/device/DeviceFetchViewData";
import {
  IDeviceProperties,
  DeviceProperties,
} from "../../models/device/DeviceProperties";
import { IDeviceGuidData } from "../../models/device/DeviceGuidData";
import IConnectDeviceViewData, {
  defaultConnectDeviceViewData,
} from "../../models/device/ConnectDeviceViewData";
import DeviceFetchData from "../../models/device/DeviceFetchData";
import IDirectionData, {
  defaultDirectionData,
  DirectionData,
} from "../../models/direction/directionData";
import IInstrumentTypeData from "../../models/instrument/InstrumentTypeData";
import { PropertyTypeData } from "../../models/propertyType/PropertyTypeData";
import { Translation } from "react-i18next";
import { ABB_VIEW, ABB_HIDE } from "../../utilities/IconConstants";
import * as _ from "lodash";
import networkConnectionActions from "../../flux/actions/NetworkConnectionAction";
import networkConnectionListStore from "../../flux/stores/networkConnection/ListStore";
import INetworkConnectionData from "../../models/networkConnection/NetworkConnectionData";
import NoDataFound from "../shared/NoDataFound";
import utility from "../shared/Utility";
import i18next from "i18next";
// Todo: Understand
type PropsType = RouteComponentProps & {};
// End

interface IFormState {
  instrumentFormData: IInstrumentFormData;

  mappingProperties: IInstrumentProperty[];
  propertiesAvailableForMapping: any[];
  newPropertiesAddedForMapping: any[];
  connectFormData: IConnectFormData;
  isInstrumentConnected: boolean;
  dirItems: string[];
  fileItems: string[];
  directionsList: any[];
  selectedInstrumentType: IInstrumentTypeViewData;
  instrumentTypeProperties: IPropertyViewData[];

  instrumentTypeList: any[];
  fetchedProperties: IDeviceProperties[];
  path: string;

  isPropertyClicked: boolean;
  selectedDirections: any[];
  selectedType: any[];
  fetchedIndeterminate: ThreeStateValue;
  clearMappingOnInstrumentTypeChange: boolean;
  isPasswordEncrypted: boolean;
  clearMappingOnDirectionChange: boolean;
  oldInstrumentData: IInstrumentFormData;
  oldConnectedData: IConnectFormData;
  isRevelPassword: boolean;
  formLoading: boolean;
  ipError: boolean;
  portError: boolean;
  usernameError: boolean;
  passwordError: boolean;
  freqError: boolean;
  codeError: boolean;
  nameError: boolean;
  serialNoError: boolean;
  dirError: boolean;
  pathError: boolean;
  networkSelectedType: any[];
  networkConnectionsList: any[];
  isIp: boolean;
  isFetch: boolean;
  browseDisabled: boolean;
  isDuplicateIp: boolean;
  multimodeInstrument: {
    showMultimodeInstrumentDialog: boolean;
    isMultimodeInstrument: boolean;
    message: string;
  };
  openAuoLineDialog:boolean;
  customIdError: boolean;
  isPropertyInUse: boolean;
  mappingPropertyIndex: any;
}

class Form
  extends React.Component<PropsType, IFormState>
  implements IFormComponent
{
  private _mount: boolean;
  private _isBrowseDisabled: boolean = true;
  private _noPropertyMapped: string = "No Property Mapped";
  private _instrumentTypeList: any[] = [];
  private _directionsList: any[] = [];
  private _selectedInstrumentType: IInstrumentTypeViewData;
  private _deviceGuidData: IDeviceGuidData;
  private _connectedDeviceData: IConnectDeviceViewData;
  private _deviceFetchedData: IDeviceFetchViewData;
  private _messages: string[];
  private _id: string;
  private _isReload: boolean;
  private _directions: any;
  private _validIp: boolean;
  private _clearMappingOnDirectionChange: boolean = false;
  private _networkConnectionsList: any[] = [];
  private _propertyData: any;
  private _propertyInUse: any;
  private _duplicateMappingProperties:any;
  private _selectedType:any;
  private _PropertyAvailableForMapping:any;
  private _newMappingProperties:any;

  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state as IFormState;
    this.state = {
      ...pushStateData,
      isInstrumentConnected: false,
      dirItems: [],
      fileItems: [],
      directionsList: [],
      selectedInstrumentType: undefined,
      instrumentTypeProperties: [],
      instrumentTypeList: [],
      fetchedProperties: [],
      path: "",
      isPropertyClicked: false,
      selectedDirections: [],
      selectedType: [],
      fetchedIndeterminate: ThreeStateValue.Unchecked,
      mappingProperties: [],
      propertiesAvailableForMapping: [],
      newPropertiesAddedForMapping: [],
      clearMappingOnInstrumentTypeChange: false,
      isPasswordEncrypted: false,
      clearMappingOnDirectionChange: false,
      oldInstrumentData: { ...pushStateData?.instrumentFormData },
      oldConnectedData: { ...pushStateData?.connectFormData },
      isRevelPassword: false,
      formLoading: false,
      ipError: false,
      portError: false,
      usernameError: false,
      passwordError: false,
      freqError: false,
      codeError: false,
      nameError: false,
      serialNoError: false,
      dirError: false,
      pathError: false,
      networkSelectedType: [],
      networkConnectionsList: [],
      isIp: false,
      isFetch: false,
      browseDisabled: true,
      isDuplicateIp: false,
      multimodeInstrument: {
        showMultimodeInstrumentDialog: false,
        isMultimodeInstrument: false,
        message: "",
      },
      openAuoLineDialog : false,
      customIdError: false,
      isPropertyInUse: false,
      mappingPropertyIndex: 0
    };
    this._mount = false;
    this._connectedDeviceData = defaultConnectDeviceViewData;
    this._deviceFetchedData = defaultDeviceFetchViewData;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  private getDirectionData = () => {
    directionActions.getAll().then(() => {
      this.setState(
        {
          directionsList: this._directionsList,
        },
        () => {
          const selectedDirections: any[] = [];
          this.state.instrumentFormData.directions.forEach((direction) => {
            selectedDirections.push({
              value: direction.id,
              label: direction.name,
            });
          });

          this.setState({
            selectedDirections,
          });
        }
      );
    });
  };

  private getNetworkConnectionData = () => {
    networkConnectionActions.getAll().then(() => {
      this.setState(
        {
          networkConnectionsList: this._networkConnectionsList,
        },
        () => {
          if (
            this.state.instrumentFormData.isEditMode !== undefined &&
            this.state.instrumentFormData.isEditMode
          ) {
            const networkSelected = this.state.networkConnectionsList.find(
              (x) => x.label === this.state.connectFormData.connectionType
            );
            this.setState({
              networkSelectedType: [networkSelected],
            });
          }
        }
      );
    });
  };

  componentDidMount() {
    this._mount = true;

    this.getNetworkConnectionData();
    this.getDirectionData();
    instrumentTypeActions
      .getAll(
        1,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        const selectedType = [
          {
            value: this.state.instrumentFormData.instrumentType.id,
            label: this.state.instrumentFormData.instrumentType.name,
          },
        ];
        this.setState(
          {
            instrumentTypeList: this._instrumentTypeList,
          },
          () => {
            if (this.state.instrumentFormData?.instrumentType?.id) {
              this.setState({
                selectedType,
              });
            }
          }
        );
      });

    if (this.state.instrumentFormData.isEditMode) {
      this.validate();
      instrumentTypeActions
        .getById(this.state.instrumentFormData.instrumentType.id)
        .then(() => {
          const propertiesAvailableForMapping: any[] = [];

          this._selectedInstrumentType.properties.forEach((item) => {
            propertiesAvailableForMapping.push({
              value: item.id,
              label: item.name,
              customId: item.customId,
              decimal: item.decimal
            });
          });
          const isIp =
            this.state.connectFormData.connectionType === "Ftp" ||
            this.state.connectFormData.connectionType === "Sftp"
              ? true
              : false;
          this.setState(
            {
              selectedInstrumentType: this._selectedInstrumentType,
              propertiesAvailableForMapping,
              isIp,
            },
            () => {
              let mappingProperties = this.state.mappingProperties;
              let fetchedProperties = this.state.fetchedProperties;
              this.state.instrumentFormData?.properties?.forEach(
                (property: any, index) => {
                  fetchedProperties.push(
                    new DeviceProperties(
                      property.instrumentPropertyId,
                      property.instrumentPropertyName,
                      property.unit,
                      true,
                      index,
                      property.id
                    )
                  );

                  const instrumentProperty = new InstrumentProperty(
                    property.id,
                    property.name,
                    property.instrumentPropertyId,
                    property.instrumentPropertyName,
                    property.direction,
                    property.min,
                    property.max,
                    property.customId,
                    property.unit,
                    property.decimals,
                    property.description,
                    false,
                    property.type,
                    property.id,
                    true
                  );

                  instrumentProperty.selectedProperty = [
                    {
                      value: property.id,
                      label: property.name,
                    },
                  ];

                  instrumentProperty.selectedDirection = [
                    {
                      value: property.direction.id,
                      label: property.direction.name,
                    },
                  ];
                  if (!this.state.instrumentFormData.isEditMode) {
                    let directionData: any[] = [];
                    property.direction.map((element: any) => {
                      directionData.push({
                        value: element.id,
                        label: element.name,
                      });
                    });
                    instrumentProperty.selectedDirection = directionData;
                  }
                  mappingProperties.push(instrumentProperty);
                  if (this.state.instrumentFormData.isEditMode) {
                    const arrayHashmap = mappingProperties.reduce((obj:any, item:any) => {
                      obj[item.id] ? obj[item.id].selectedDirection.push(...item.selectedDirection) : (obj[item.id] = { ...item });
                      obj[item.id].selectedDirection = utility.removeDuplicatefromArray(obj[item.id].selectedDirection);
                      return obj;
                    }, {});
                    mappingProperties = Object.values(arrayHashmap);
                  }
                  let filteredfetchedProperties:any = fetchedProperties.filter((obj: any, index: any) => {
                    return index === fetchedProperties.findIndex((i:any) => obj.id === i.id)
                  })
                  fetchedProperties = filteredfetchedProperties.map((obj: any, index: any) => {
                    obj.index = index
                    return obj;
                  })
                }
              );
              this._duplicateMappingProperties = JSON.stringify(mappingProperties)
              this.setState(
                {
                  fetchedProperties,
                  mappingProperties,
                  fetchedIndeterminate: ThreeStateValue.Checked,
                },
                () => {
                  this.validate();
                  this.forceUpdate();
                }
              );
            }
          );
        });
    }

    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_INSTRUMENT,
        action: this.state.instrumentFormData.isEditMode
          ? CONSTANTS.EDIT
          : CONSTANTS.CREATE,
        icon: this.state.instrumentFormData.isEditMode
          ? ICONCONSTANTS.ABB_EDIT
          : ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.INSTRUMENT_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    instrumentFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isReload = false;
        this._id = state.instrumentId;
        this._messages = state.message;
      }
    });

    // directions list
    directionListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.directionDataList.forEach((data: any) => {
          const direction = {
            label: data.name,
            value: data.id,
          };
          this._directionsList.push(direction);
        });
      }
    });

    networkConnectionListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.networkConnectionDataList.forEach((data: any) => {
          const networkConnection = {
            label: data.name,
            value: data.id,
          };
          this._networkConnectionsList.push(networkConnection);
        });
      }
    });

    instrumentTypeByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._selectedInstrumentType = state.data;
      }
    });

    // instrument type list
    instrumentTypeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.data.result.forEach((data: any) => {
          const type = {
            label: data.name,
            value: data.id,
          };
          this._instrumentTypeList.push(type);
        });
      }
    });

    deviceGuidStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._deviceGuidData = state.deviceGuidData;
      }
    });

    connectDeviceStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._connectedDeviceData = state.connectedDeviceData;
      }
    });

    fetchDataStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._deviceFetchedData = state.deviceFetchData;
      }
    });

    instrumentCheckDuplicateIpStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        let isdupIp = state.isDuplicateIp !== "" ? true : false;
        this.setState(
          {
            isDuplicateIp: isdupIp,
            multimodeInstrument: {
              isMultimodeInstrument: this.state.isDuplicateIp,
              showMultimodeInstrumentDialog: this.state.isDuplicateIp,
              message: state.isDuplicateIp,
            },
          },
          this.validate
        );
        this._messages = state.message;
        if (isdupIp) {
          this.openDuplicateIpDialog();
        }
      }
    });
    getPropertyStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._propertyData = state.data.data;
      }
    });
    instrumentActions.getPropertyDetails().then()
    checkPropertyInUseStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._propertyInUse = state.data.data;
      }
    });
    if (this.state.instrumentFormData.isEditMode) {
      this.checkDuplicateIPandPort(this.state.isIp);
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (
      JSON.stringify(this.state.oldInstrumentData) !==
        JSON.stringify(this.state.instrumentFormData) ||
      JSON.stringify(this.state.oldConnectedData) !==
        JSON.stringify(this.state.connectFormData)
    ) {
      navigationHeaderActions
        .updateHeader({
          name: CONSTANTS.MODULE_INSTRUMENT,
          action: this.state.instrumentFormData.isEditMode
            ? CONSTANTS.EDIT
            : CONSTANTS.CREATE,
          icon: this.state.instrumentFormData.isEditMode
            ? ICONCONSTANTS.ABB_EDIT
            : ICONCONSTANTS.ABB_PLUS,
          goBackUrl: CONSTANTS.INSTRUMENT_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
          isDataChanged: true,
        })
        .then();
    }

    if (prevState.selectedDirections !== this.state.selectedDirections) {
      if (prevState.selectedDirections > this.state.selectedDirections) {
        this.setState({ clearMappingOnDirectionChange: true });
      }
    }
  }

  private onManualClick = (data: boolean) => {
    this.setState({
      instrumentFormData: {
        ...this.state.instrumentFormData,
        isCreatedManually: !this.state.instrumentFormData.isCreatedManually,
      },
      mappingProperties: [],
    });
  };

  private performTypeChange = () => {
    const val = this.state.selectedType;

    const fetchedProperties = this.state.fetchedProperties;
    fetchedProperties.forEach((d) => (d.isSelected = false));

    this.setState({
      clearMappingOnInstrumentTypeChange: false,
      mappingProperties: [],
      fetchedProperties,
      fetchedIndeterminate: ThreeStateValue.Unchecked,
      instrumentFormData: {
        ...this.state.instrumentFormData,
        properties: [],
      }
    });
    this._duplicateMappingProperties = "";
    this._newMappingProperties = "";
    if (val[0].isNew) {
      val[0].value = CONSTANTS.DefaultGuid;
    }
    if (!val[0].isNew) {
      instrumentTypeActions.getById(val[0].value).then(() => {
        const propertiesAvailableForMapping: any[] = [];
        this._selectedInstrumentType.properties.forEach((item) => {
          propertiesAvailableForMapping.push({
            value: item.id,
            label: item.name,
            customId: item.customId,
            decimal: item.decimal
          });
        });

        this.setState({
          selectedInstrumentType: this._selectedInstrumentType,
          propertiesAvailableForMapping,
        });
      });
    } else {
      this._selectedInstrumentType = new InstrumentTypeViewData(
        val[0].value,
        val[0].label,
        val[0].label,
        []
      );
      this.setState({
        selectedInstrumentType: defaultInstrumentTypeData,
      });
    }
  };

  private performDirectionChange = () => {
    this.setState({
      clearMappingOnDirectionChange: false,
    });
  };

  private onCloseIntrumentTypeChange = () => {
    const selectedType = JSON.parse(this._selectedType)
    const propertyAvailableForMapping = JSON.parse(this._PropertyAvailableForMapping)
    this.setState({
      selectedType: selectedType,
      propertiesAvailableForMapping: propertyAvailableForMapping,
      selectedInstrumentType: selectedType,
      clearMappingOnInstrumentTypeChange: false
    })
  }

  private typeChangeHandler = (val: any) => {
    if (
      this.state.selectedType.length &&
      this.state.selectedType[0].value === val[0].value &&
      this.state.selectedType[0].label === val[0].label
    ) {
      this.setState(
        {
          selectedType: val,
          selectedInstrumentType: val,
        },
        this.performTypeChange
      );
    } else {
      if (val[0].isNew) {
        val[0].value = CONSTANTS.DefaultGuid;
      }
      this._selectedInstrumentType = new InstrumentTypeViewData(
        val[0].value,
        val[0].label,
        val[0].label,
        []
      );
      const isEmptyselectedType = this.state.selectedType.length  ? true : false
      this._PropertyAvailableForMapping = JSON.stringify(this.state.propertiesAvailableForMapping)
      this._selectedType = JSON.stringify(this.state.selectedType)
      this.setState({
        selectedType: val,
        propertiesAvailableForMapping: [],
        selectedInstrumentType: defaultInstrumentTypeData,
        clearMappingOnInstrumentTypeChange: this.state.selectedType.length
          ? true
          : false,
      },() => {
        if(!isEmptyselectedType){
          this.performTypeChange();
        }
      });
    }
  };

  private directionChangehandler = (val: any) => {
    if (this.state.selectedDirections >= val) {
      this._directions = this.state.selectedDirections;
    }
    this.setState(
      {
        selectedDirections: val,
        clearMappingOnDirectionChange: false,
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  private networkConnectionChangehandler = (val: any) => {
    if (this.state.networkSelectedType >= val) {
      this._networkConnectionsList = this.state.networkSelectedType;
    }
    this.setState(
      {
        connectFormData: {
          ...this.state.connectFormData,
          connectionType: val[0].label,
          connectionTypeId: val[0].value,
          ipAddress: "",
          username: "",
          password: "",
          dir: "",
        },
        instrumentFormData: {
          ...this.state.instrumentFormData,
          codeId: "",
        },
        fetchedProperties: [],
        networkSelectedType: val,
      },
      () => {
        this.forceUpdate();
        if (val[0].label === "Ftp" || val[0].label === "Sftp") {
          this.setState(
            {
              isIp: true,
              browseDisabled: false,
            },
            () => {
              if (val[0].label === "Sftp") {
                this.setState({
                  connectFormData: {
                    ...this.state.connectFormData,
                    port: 22,
                  },
                });
              } else {
                this.setState({
                  connectFormData: {
                    ...this.state.connectFormData,
                    port: 21,
                  },
                });
              }
            }
          );
        } else {
          this.setState({
            isIp: false,
            browseDisabled: false,
          });
        }
      }
    );
  };

  private setIpAddress = (value: string) => {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        value
      )
    ) {
      this.setState(
        {
          ipError: false,
          isDuplicateIp: false,
          connectFormData: {
            ...this.state.connectFormData,
            ipAddress: value,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          ipError: true,
          connectFormData: {
            ...this.state.connectFormData,
            ipAddress: value,
          },
        },
        this.validate
      );
    }
  };

  private setPort = (value: any) => {
    if (value.trim() && /^[0-9]*$/g.test(value) && value.length < 6) {
      this.setState(
        {
          portError: false,
          isDuplicateIp: false,
          connectFormData: {
            ...this.state.connectFormData,
            port: value,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          portError: true,
          connectFormData: {
            ...this.state.connectFormData,
            port: value,
          },
        },
        this.validate
      );
    }
  };

  private checkDuplicateIPandPort = (isIp: boolean) => {
    const address = isIp
      ? this.state.connectFormData.ipAddress
      : this.state.connectFormData.dir;
    const port = this.state.connectFormData.port;
    if (address) {
      this.setState({
        formLoading: true,
        isDuplicateIp: false,
      });
      var id = this.state.instrumentFormData.isEditMode
        ? this.state.instrumentFormData.id
        : "";
      instrumentActions
        .checkDuplicateIP(address, port, id, uuidv4(), isIp)
        .then(() => {
          this.setState({
            formLoading: false,
          });
        })
        .catch((error) => {
          this.setState(
            {
              formLoading: false,
            },
            () => triggerNotifications.errors(error.message, error.data)
          );
        });
    } else {
      this.setState({
        formLoading: false,
        isDuplicateIp: false,
      });
    }
  };

  private setUserName = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      this.setState(
        {
          usernameError: false,
          connectFormData: {
            ...this.state.connectFormData,
            username: value,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          usernameError: true,
          connectFormData: {
            ...this.state.connectFormData,
            username: value,
          },
        },
        this.validate
      );
    }
  };

  private setPassword = (value: string) => {
    if (value.trim()) {
      this.setState(
        {
          passwordError: false,
          connectFormData: {
            ...this.state.connectFormData,
            password: value,
          },
          isPasswordEncrypted: false,
        },
        this.validate
      );
    } else {
      this.setState(
        {
          passwordError: true,
          connectFormData: {
            ...this.state.connectFormData,
            password: value,
          },
          isPasswordEncrypted: false,
        },
        this.validate
      );
    }
  };

  private setAutoLine = () => {
    
    this.setState(
      {
        connectFormData: {
          ...this.state.connectFormData,
          isAutoLine: !this.state.connectFormData.isAutoLine,
        },
        openAuoLineDialog:false,
        mappingProperties:[],
        fetchedProperties:[]
      },
      () => {
        const selectedDirections: any[] = [];
        if (this.state.connectFormData.isAutoLine) {
          this._directionsList.forEach((direction) => {
            if (direction.label === CONSTANTS.ND || direction.label === "--") {
              selectedDirections.push({
                value: direction.value,
                label: direction.label,
              });
            }
          });
        } else {
          if (!this.state.connectFormData.isAutoLine) {
            let removeIndex;
            for (let i = 0; i < selectedDirections.length; i++) {
              if (
                selectedDirections[i].label === CONSTANTS.ND ||
                selectedDirections[i].label === "--"
              ) {
                removeIndex = i;
              }
            }
            selectedDirections.splice(1, removeIndex);
          }
        }
        this.setState({
          selectedDirections,
        });
      }
    );
  };

  
  private openAutoLineIns = ()=>{
    if(this.state.mappingProperties && this.state.mappingProperties.length &&  this.state.connectFormData.username.length &&
      this.state.connectFormData.password.length && this.state.instrumentFormData.name.trim()){
      this.setState({
        openAuoLineDialog : true
      })
    } else {
      this.setAutoLine()
    }
  }
  private setDirectory = (value: string) => {
    if (value.split(".").pop() === "xml") {
      this.setState(
        {
          isFetch: true,
        },
        this.validate
      );
    } else {
      this.setState(
        {
          isFetch: false,
        },
        this.validate
      );
    }
    if (!CONSTANTS.NETWORKSHARINGREGEXP.test(value)) {
      this.setState(
        {
          dirError: false,
          connectFormData: {
            ...this.state.connectFormData,
            dir: value,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          dirError: true,
          connectFormData: {
            ...this.state.connectFormData,
            dir: value,
          },
        },
        this.validate
      );
    }
  };

  private setpath = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (!rgFile.test(value)) {
      this.setState({
        pathError: false,
        connectFormData: {
          ...this.state.connectFormData,
          path: value,
        },
      });
    } else {
      this.setState({
        pathError: true,
        connectFormData: {
          ...this.state.connectFormData,
          path: value,
        },
      });
    }
  };

  private setPollingFrequency = (value: string) => {
    if (value.length < 3) {
      this.setState(
        {
          connectFormData: {
            ...this.state.connectFormData,
            pollingFrequency: Number(value),
          },
        },
        this.validate
      );
    }
  };

  private setCodeId = (value: string) => {
    if (value.trim() && /^[a-zA-Z0-9 ]*$/g.test(value)) {
      this.setState(
        {
          codeError: false,
          instrumentFormData: {
            ...this.state.instrumentFormData,
            codeId: value,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          codeError: true,
          instrumentFormData: {
            ...this.state.instrumentFormData,
            codeId: value,
          },
        },
        this.validate
      );
    }
  };

  private setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    if (value.trim() && !utility.not_Allow_Char_in_UserName(value)) {
      this.setState(
        {
          nameError: false,
          instrumentFormData: {
            ...this.state.instrumentFormData,
            name: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          nameError: true,
          instrumentFormData: {
            ...this.state.instrumentFormData,
            name: val,
          },
        },
        this.validate
      );
    }
  };

  private setSerialNumber = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    if (value.trim() && /^[0-9 ]*$/g.test(value)) {
      this.setState(
        {
          serialNoError: false,
          instrumentFormData: {
            ...this.state.instrumentFormData,
            serialNumber: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          serialNoError: true,
          instrumentFormData: {
            ...this.state.instrumentFormData,
            serialNumber: val,
          },
        },
        this.validate
      );
    }
  };

  private setDescription = (value: string) => {
    this.setState({
      instrumentFormData: {
        ...this.state.instrumentFormData,
        description: value,
      },
    });
  };

  private fetchProperties = (file: string, netShare?: boolean) => {
    let fetchedProperties: any[] = this.state.fetchedProperties;
    let mappingProperties: any[] = this.state.mappingProperties;
    let properties = this.state.instrumentFormData.properties;
    if (this.state.connectFormData.path !== file) {
      fetchedProperties = [];
      mappingProperties = [];
      properties = [];
    }
    this._deviceFetchedData.properties = [];
    this.setState(
      {
        connectFormData: {
          ...this.state.connectFormData,
          path: file,
        },
        instrumentFormData: {
          ...this.state.instrumentFormData,
          properties,
        },
        fetchedProperties,
        mappingProperties,
      },
      () => {
        connectionActions.getKey().then(() => {
          const encPassword = encryption.encrypt(
            this.state.connectFormData.password,
            this._deviceGuidData.key
          );
          const connectionData = this.state.connectFormData;
          const dirPath = netShare
            ? this.state.connectFormData.dir.substring(
                0,
                this.state.connectFormData.dir.lastIndexOf("\\")
              )
            : connectionData.dir;

          const localFormData = new DeviceFetchData(
            connectionData.ipAddress,
            connectionData.username,
            encPassword,
            true,
            connectionData.isAutoLine,
            dirPath,
            file,
            connectionData.connectionId,
            connectionData.connectionType,
            connectionData.port
          );
          connectionActions
            .fetch(localFormData, this._deviceGuidData.id)
            .then(() => {
              let fetchedProperties: any[] = [];
              let mappingProperties: any[] = [];
              let fetchedIndeterminate: ThreeStateValue =
                ThreeStateValue.Unchecked;
              if (this.state.instrumentFormData.properties.length === 0) {
                this._deviceFetchedData.properties.forEach(
                  (item: any, index: number) => {
                    fetchedProperties.push(
                      new DeviceProperties(
                        item.id,
                        item.name,
                        item.unit,
                        false,
                        index,
                        null
                      )
                    );
                  }
                );
                fetchedIndeterminate = ThreeStateValue.Unchecked;
              } else {
                // TODO
                this.state.instrumentFormData?.properties?.forEach(
                  (item, index) => {
                    fetchedProperties.push(
                      new DeviceProperties(
                        item.instrumentPropertyId,
                        item.instrumentPropertyName,
                        item.unit,
                        true,
                        index,
                        item.id,
                      )
                    );
                    let mappedData = this.state.mappingProperties.find((el:any)=>el.instrumentPropertyId === item.instrumentPropertyId);
                    if(mappedData)
                    mappingProperties.push(mappedData);
                    const arrayHashmap = mappingProperties.reduce((obj:any, item:any) => {
                      obj[item.id] ? obj[item.id].selectedDirection.push(...item.selectedDirection) : (obj[item.id] = { ...item });
                      obj[item.id].selectedDirection = utility.removeDuplicatefromArray(obj[item.id].selectedDirection);
                      return obj;
                    }, {});
                    mappingProperties = Object.values(arrayHashmap);
                  }
                );

                let index = fetchedProperties.length - 1;

                this._deviceFetchedData.properties.forEach((item: any) => {
                  index = index + 1;
                  if (
                    !fetchedProperties
                      .map((d) => d.id)
                      .includes(item.id)
                  ) {
                    fetchedProperties.push(
                      new DeviceProperties(
                        item.id,
                        item.name,
                        item.unit,
                        false,
                        index,
                        null
                      )
                    );
                  }
                });

                if (
                  fetchedProperties.some((d) => d.isSelected) &&
                  fetchedProperties.some((d) => !d.isSelected)
                ) {
                  fetchedIndeterminate = ThreeStateValue.Indeterminate;
                }
              }
              let filteredfetchedProperties:any = fetchedProperties.filter((obj: any, index: any) => {
                return index === fetchedProperties.findIndex((i:any) => obj.id === i.id)
              })
              fetchedProperties = filteredfetchedProperties.map((obj: any, index: any) => {
                obj.index = index
                return obj;
              })
              if (this.state.instrumentFormData.isEditMode) {
                this.setState({
                  isInstrumentConnected: false,
                  instrumentFormData: {
                    ...this.state.instrumentFormData,
                    codeId: this._deviceFetchedData.codeId,
                  },
                  fetchedProperties,
                  fetchedIndeterminate,
                  mappingProperties
                });
              } else {
                this.setState({
                  isInstrumentConnected: false,
                  instrumentFormData: {
                    ...this.state.instrumentFormData,
                    serialNumber: this._deviceFetchedData.serialNumber
                      ? this._deviceFetchedData.serialNumber
                      : this.state.instrumentFormData.serialNumber,
                    codeId: this._deviceFetchedData.codeId
                      ? this._deviceFetchedData.codeId
                      : this.state.instrumentFormData.codeId,
                    name: this._deviceFetchedData.name
                      ? this._deviceFetchedData.name
                      : this.state.instrumentFormData.name,
                  },
                  fetchedProperties,
                  fetchedIndeterminate,
                });
              }
            })
            .catch((error) =>
              triggerNotifications.errors(error.message, error.data)
            );
        });
      }
    );
  };

  private fetchFiles = (dir: string, netShare: boolean, isFile: boolean) => {
    let dirBind: string = "";
    if (
      this.state.networkSelectedType[0].label === "Network Sharing" &&
      netShare
    ) {
      dirBind = this.state.connectFormData.dir + "\\" + dir;
    } else {
      dirBind = dir;
    }
    this.setState(
      {
        connectFormData: {
          ...this.state.connectFormData,
          dir: dirBind,
          isFile,
        },
      },
      () => {
        connectionActions.getKey().then(() => {
          const encPassword = encryption.encrypt(
            this.state.connectFormData.password,
            this._deviceGuidData.key
          );
          const connectionData = this.state.connectFormData;
          const localFormData = new ConnectFormData(
            connectionData.ipAddress,
            connectionData.username,
            encPassword,
            connectionData.isFile,
            connectionData.isAutoLine,
            connectionData.dir,
            connectionData.pollingFrequency,
            connectionData.path,
            connectionData.connectionId,
            connectionData.connectionType,
            connectionData.connectionTypeId,
            connectionData.networkConnection,
            connectionData.port
          );
          connectionActions
            .connect(localFormData, this._deviceGuidData.id)
            .then(() => {
              if (!netShare) {
                this.setState({
                  isInstrumentConnected: true,
                });
              }
              if (this.state.connectFormData.isFile) {
                const fileItems: any[] = this._connectedDeviceData.items;
                this.setState({
                  fileItems,
                });
              } else {
                const dirItems: any[] = this._connectedDeviceData.items;
                this.setState({
                  dirItems,
                });
              }
            })
            .catch((error) => {
              if (!netShare) {
                this.setState({
                  isInstrumentConnected: false,
                });
              }
              triggerNotifications.errors(error.message, error.data);
            });
        });
      }
    );
  };

  private onBrowseClick = () => {
    if (this.state.connectFormData.dir !== "") {
      if (this.state.connectFormData.dir.split(".").pop() === "xml") {
        const filename = this.state.connectFormData.dir.replace(
          /^.*[\\\/]/,
          ""
        );
        this.fetchProperties(filename, true);
      } else {
        this.fetchFiles(this.state.connectFormData.dir, false, false);
      }
    } else {
      connectionActions.getKey().then(() => {
        const encPassword = encryption.encrypt(
          this.state.connectFormData.password,
          this._deviceGuidData.key
        );

        this.setState(
          {
            connectFormData: {
              ...this.state.connectFormData,
              isFile: false,
            },
          },
          () => {
            const connectionData = this.state.connectFormData;
            const localFormData = new ConnectFormData(
              connectionData.ipAddress,
              connectionData.username,
              encPassword,
              connectionData.isFile,
              connectionData.isAutoLine,
              connectionData.dir,
              connectionData.pollingFrequency,
              connectionData.path,
              connectionData.connectionId,
              connectionData.connectionType,
              connectionData.connectionTypeId,
              connectionData.networkConnection,
              connectionData.port
            );
            connectionActions
              .connect(localFormData, this._deviceGuidData.id)
              .then(() => {
                if (!this.state.connectFormData.isFile) {
                  const dirItems: any[] = this._connectedDeviceData.items;
                  this.setState(
                    {
                      dirItems,
                    },
                    () => {
                      this.setState({
                        isInstrumentConnected: true,
                      });
                    }
                  );
                }
              })
              .catch((error) =>
                triggerNotifications.errors(error.message, error.data)
              );
          }
        );
      });
    }
  };

  private onCloseDialog = () => {
    this.setState({
      fileItems: [],
      isInstrumentConnected: false,
      connectFormData: {
        ...this.state.connectFormData,
      },
    });
  };

  isConnectValid(): boolean {
    if (this.state.networkSelectedType.length > 0) {
      if (
        this.state.networkSelectedType[0]?.label === "Ftp" ||
        this.state.networkSelectedType[0]?.label === "Sftp"
      ) {
        if (
          this.state.connectFormData.ipAddress === "" ||
          this.state.connectFormData.username.trim() === "" ||
          this.state.connectFormData.password.trim() === ""
        ) {
          this.setState({
            browseDisabled: true,
          });
        } else {
          this.setState({
            browseDisabled: false,
          });
        }
      } else {
        if (this.state.connectFormData.dir === "") {
          this.setState({
            browseDisabled: true,
          });
        } else {
          this.setState({
            browseDisabled: false,
          });
        }
      }
    } else {
      if (
        this.state.instrumentFormData.isEditMode &&
        this.state.connectFormData.connectionType === "Network Sharing"
      ) {
        this.setState({
          browseDisabled: false,
        });
      } else {
        this.setState({
          browseDisabled: true,
        });
      }
    }
    this._isBrowseDisabled = this.state.browseDisabled;
    return this.state.browseDisabled;
  }

  validate(): void {
    const invalidaMappings = this.state.mappingProperties.filter(
      (d) => d.customId === 0
    );
    if (
      !this.state.ipError &&
      !this.state.portError &&
      !this.state.usernameError &&
      !this.state.passwordError &&
      !this.state.freqError &&
      !this.state.codeError &&
      !this.state.nameError &&
      !this.state.serialNoError &&
      !this.isConnectValid() &&
      this.state.instrumentFormData.name.trim() &&
      this.state.instrumentFormData.codeId &&
      this.state.instrumentFormData.serialNumber &&
      invalidaMappings.length === 0 &&
      this.state.mappingProperties.length > 0 &&
      this.state.connectFormData.username.length &&
      this.state.connectFormData.password.length
    ) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_INSTRUMENT,
          isSubmitDisabled: false,
        })
        .then();
    } else {
      if (
        this.state.connectFormData.connectionType === "Network Sharing" &&
        this.state.connectFormData.username.length &&
        this.state.connectFormData.password.length
      ) {
        submitHeaderActions
          .update({
            moduleName: CONSTANTS.MODULE_INSTRUMENT,
            isSubmitDisabled: false,
          })
          .then();
      } else {
        submitHeaderActions
          .update({
            moduleName: CONSTANTS.MODULE_INSTRUMENT,
            isSubmitDisabled: true,
          })
          .then();
      }
    }
  }

  private addingErrorClass = () => {
    const samePropertyValidation:any = []
    this.state.mappingProperties?.filter((x:any) => {
      return x.id === CONSTANTS.DefaultGuid || x.id === x.customId
    }).map((i:any) => {
      const propFilter = this._propertyData?.filter((item:any) => {
        return Number(i.customId) === item.id
      })
      propFilter && propFilter?.length !==0 ? samePropertyValidation.push(propFilter[0]) : []
    })
    if(samePropertyValidation && samePropertyValidation?.length !== 0){
      const sameProp = utility.removeDuplicatefromArrayBasedOnId(samePropertyValidation);
      const mappingProperties:any = this.state.mappingProperties
      mappingProperties.map((i:any) => {
        sameProp.map((x:any) => {
          if(Number(x.id) === Number(i.customId)){
            i.isError = true;
          }
        })
      })
      this.setState(mappingProperties)
      triggerNotifications.error(i18next.t("Property with same Id already exists"));
      return false
    } else{
      return true
    }
  }

  private onSubmitAction = () => {
    for (let i = 0; i < this.state.mappingProperties.length; i++) {
      if (this.state.mappingProperties[i]?.customId === 0) {
        triggerNotifications.error(i18next.t("Property Id is required")).then();
        return false;
      }
      if(this.state.mappingProperties[i]?.selectedProperty?.length === 0){
        triggerNotifications.error(i18next.t("Property Name is required")).then();
        return false;
      }
      if(this.state.mappingProperties[i]?.selectedDirection?.length === 0){
        triggerNotifications.error(i18next.t(CONSTANTS.DIRECTION_MESSAGE)).then();
        return false;
      }
      if(this.state.mappingProperties[i]?.isError){
        triggerNotifications.error(i18next.t("Property with same Id already exists")).then();
        return false;
      }
      if (
        this.state.instrumentFormData.isCreatedManually &&
        this.state.mappingProperties[i]?.instrumentPropertyName?.toString() === ""
      ) {
        triggerNotifications.error(i18next.t("Property Name is required")).then();
        return false;
      }
    }
    // if (!this.state.instrumentFormData.serialNumber.length) {
    //   triggerNotifications.error(i18next.t("Serial Number Required"));
    //   return false;
    // }
    var customIdArray = this.state.mappingProperties.map((item:any) => { return `${item.customId}` });
    var isDuplicate = customIdArray.some((item, idx) => { 
        return customIdArray.indexOf(item) != idx 
    });
    if(isDuplicate){
      triggerNotifications.error(i18next.t("Properties cannot have same Id values"));
      return false;
    }
    if (this.state.instrumentFormData.isEditMode) {
      if(this.addingErrorClass()){
        this.onSaveClick();
      }
    } else {
      if(this.addingErrorClass()){
        this.onCreateClick();
      }
    }
  };

  public onSaveClick = () => {
    this.setState({
      formLoading: true,
    });
    connectionActions
      .getKey()
      .then(() => {
        const connectionFormData = this.getConnectionFormData();
        const instrumentFormData = this.getInstrumentFormData();
        let checkDirection;
        const dt: any[] = [];
        let isAllMapped: boolean = true;
        this.state.mappingProperties.map((mapped: any) => {
          if (mapped?.selectedDirection?.length > 1) {
            this.state.selectedDirections.map((dir: any) => {
              checkDirection = mapped.selectedDirection.filter(
                (x: any) => x.value === dir.value
              );
              if (checkDirection.length > 0) {
                isAllMapped = true;
                dt.push(...checkDirection);
              }
            });
          } else {
            this.state?.selectedDirections?.map((dir: any) => {
              checkDirection = mapped.selectedDirection.filter(
                (x: any) => x.value === dir.value
              );
              if (checkDirection.length > 0) {
                isAllMapped = true;
                dt.push(...checkDirection);
              } else {
                isAllMapped = false;
              }
            });
          }
        });
        const finalData = _.xorBy(
          this.state.selectedDirections.sort(),
          dt.sort(),
          "value"
        );
        if (finalData.length === 0) {
          instrumentActions
            .put(instrumentFormData, connectionFormData, this.state.mappingProperties)
            .then(() => {
              this.setState(
                {
                  formLoading: false,
                },
                () => {
                  triggerNotifications.success(this._messages);
                  setTimeout(() => {
                    history.push(CONSTANTS.INSTRUMENT_INDEX_URL, {
                      isReloadFirst: this._isReload,
                      id: this._id,
                    });
                  }, CONSTANTS.NOTIFICATION_TIMEOUT);
                }
              );
            })
            .catch((error) => {
              this.setState(
                {
                  formLoading: false,
                },
                () =>
                  triggerNotifications.errors(error.message, error.data).then()
              );
            });
        } else {
          this.setState(
            {
              formLoading: false,
            },
            () => triggerNotifications.errors([CONSTANTS.DIRECTION_MESSAGE])
          );
        }
      })
      .catch((error) => {
        this.setState(
          {
            formLoading: false,
          },
          () => triggerNotifications.errors(error?.message, error.data).then()
        );
      });
  };

  private getInstrumentFormData(): InstrumentFormData {
    const tempName = this.state.instrumentFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState((prevState) => ({
      formLoading: true,
      instrumentFormData: {
        ...prevState.instrumentFormData,
        name: tempName,
      },
    }));
    const directions: IDirectionData[] = [];
    this.state.selectedDirections.forEach((item) => {
      directions.push({
        id: item.value,
        name: item.label,
        order: item.order,
      });
    });

    const instrumentType: IInstrumentTypeData = {
      id: this.state.selectedType[0].value,
      name: this.state.selectedType[0].label,
      description: this.state.selectedType[0].label,
    };

    const networkConnectionType: INetworkConnectionData[] = [];
    this.state.networkSelectedType.forEach((item) => {
      networkConnectionType.push({
        id: item.value,
        name: item.label,
      });
    });

    const instrumentFormData = new InstrumentFormData(
      this.state.instrumentFormData.isEditMode,
      this.state.instrumentFormData.requestId,
      this.state.instrumentFormData.id,
      this.state.instrumentFormData.name,
      this.state.instrumentFormData.codeId,
      this.state.instrumentFormData.serialNumber,
      instrumentType,
      directions,
      this.state.mappingProperties,
      this.state.instrumentFormData.description,
      this.state.instrumentFormData.isCreatedManually
    );

    return instrumentFormData;
  }

  private getConnectionFormData(): ConnectFormData {
    const encryptedPassword = encryption.encrypt(
      this.state.connectFormData.password,
      this._deviceGuidData.key
    );

    const connectionFormData = new ConnectFormData(
      this.state.connectFormData.ipAddress,
      this.state.connectFormData.username,
      encryptedPassword,
      this.state.connectFormData.isFile,
      this.state.connectFormData.isAutoLine,
      this.state.connectFormData.dir,
      this.state.connectFormData.pollingFrequency,
      this.state.connectFormData.path,
      this._deviceGuidData.id,
      this.state.connectFormData.connectionType,
      this.state.networkSelectedType[0].value,
      this.state.connectFormData.networkConnection,
      this.state.connectFormData.port
    );

    return connectionFormData;
  }

  public onCreateClick = () => {
    this.setState({
      formLoading: true,
    });
    connectionActions
      .getKey()
      .then(() => {
        const connectionFormData = this.getConnectionFormData();
        const instrumentFormData = this.getInstrumentFormData();

        let checkDirection;
        let dt: any[] = [];
        this.state.mappingProperties.map((mapped: any) => {
          if (mapped.selectedDirection.length > 1) {
            this.state.selectedDirections.map((dir: any) => {
              checkDirection = mapped.selectedDirection.filter(
                (x: any) => x.value === dir.value
              );
              if (checkDirection.length > 0) {
                dt.push(...checkDirection);
              }
            });
          } else {
            this.state.selectedDirections.map((dir: any) => {
              checkDirection = mapped.selectedDirection.filter(
                (x: any) => x.value === dir.value
              );
              if (checkDirection.length > 0) {
                dt.push(...checkDirection);
              }
            });
          }
        });

        let finalData = _.xorBy(
          this.state.selectedDirections.sort(),
          dt.sort(),
          "value"
        );

        if (finalData.length === 0) {
          instrumentActions
            .post(instrumentFormData, connectionFormData)
            .then(() => {
              this.setState(
                {
                  formLoading: false,
                },
                () => {
                  triggerNotifications.success(this._messages);
                  setTimeout(() => {
                    history.push(CONSTANTS.INSTRUMENT_INDEX_URL, {
                      isReloadFirst: this._isReload,
                      id: this._id,
                    });
                  }, CONSTANTS.NOTIFICATION_TIMEOUT);
                }
              );
            })
            .catch((error) => {
              this.setState(
                {
                  formLoading: false,
                },
                () => triggerNotifications.errors(error.message, error.data)
              );
            });
        } else {
          this.setState(
            {
              formLoading: false,
            },
            () => triggerNotifications.error(CONSTANTS.DIRECTION_MESSAGE)
          );
        }
      })
      .catch((error) => {
        this.setState(
          {
            formLoading: false,
          },
          () => triggerNotifications.errors([CONSTANTS.MANDATORY_MESSAGE])
        );
      });
  };

  private onManualAddPropertyClick = () => {
    if (this.validateMapping()) {
      const mappingProperties = this.state.mappingProperties;
      const item = new InstrumentProperty(
        "",
        "",
        "",
        "",
        [defaultDirectionData],
        0,
        0,
        0,
        "",
        2,
        "",
        false,
        new PropertyTypeData("", ""),
        ""
      );
      this.setFirstOrDefaultDirection(item);
      mappingProperties.push(item);
      this.setState({
        mappingProperties,
      });
    }
  };

  private togglePassword = () => {
    this.setState({
      isRevelPassword: !this.state.isRevelPassword,
    });
  };

  private openDuplicateIpDialog = () => {
    var multimodeInstrument = {
      showMultimodeInstrumentDialog: this.state.isDuplicateIp,
      isMultimodeInstrument: this.state.isDuplicateIp,
      message: this.state.multimodeInstrument.message,
    };
    this.setState({ multimodeInstrument: multimodeInstrument }, () => {
      this.validate();
    });
  };

  private duplicateIpDialogCancelClick = (dlg: any) => {
    dlg.close();
    if (this.state.isIp) {
      this.state.connectFormData.ipAddress = "";
    } else {
      this.state.connectFormData.dir = "";
    }
  };

  private duplicateIpDialogOkClick = () => {
    var multimodeInstrument = {
      showMultimodeInstrumentDialog: false,
      isMultimodeInstrument: true,
      message: this.state.multimodeInstrument.message,
    };
    this.setState({ multimodeInstrument: multimodeInstrument }, () => {
      this.validate();
    });
  };

  onCancelClick = () => {
    history.push(CONSTANTS.INSTRUMENT_INDEX_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };
  public deleteProperty = (rowIndex: number) => {
    const filterData = [...this.state.mappingProperties];
    filterData.splice(rowIndex, 1);

    this.setState({
      mappingProperties: filterData,
    });
  };

  public onBlur = (index: any) => {
    if(this.state.instrumentFormData?.isEditMode){
    const mappingProperties = this.state.mappingProperties;
    this.setState({mappingPropertyIndex: index})
    const id = mappingProperties[this.state.mappingPropertyIndex].id
    instrumentActions.checkPropertyInUse(id).then(() => {
      if(this._propertyInUse){
        this.setState({isPropertyInUse: true})
      } else{
        this.setState({isPropertyInUse: false})
      }
    })
  }
}

  public onCancel = () => {
    const mappingProperties = this.state.mappingProperties;
    this.setState({isPropertyInUse: false})
    const parsedValue = this._duplicateMappingProperties ? JSON.parse(this._duplicateMappingProperties) : []
    const parsedNewValue = this._newMappingProperties ? JSON.parse(this._newMappingProperties) : []
    if(parsedValue.length !== 0 && parsedValue[this.state.mappingPropertyIndex]){
      mappingProperties[this.state.mappingPropertyIndex] = parsedValue[this.state.mappingPropertyIndex]
      mappingProperties[this.state.mappingPropertyIndex].isError = false
      this.setState({mappingProperties})
    } else{
      if(parsedNewValue !== 0 && parsedNewValue[this.state.mappingPropertyIndex]){
        mappingProperties[this.state.mappingPropertyIndex] = parsedNewValue[this.state.mappingPropertyIndex]
        mappingProperties[this.state.mappingPropertyIndex].isError = false
        this.setState({mappingProperties})
      }
    }
  }

  public onConfirm = () => {
    const mappingProperties = this.state.mappingProperties;
    this.setState({isPropertyInUse: false})
    mappingProperties[this.state.mappingPropertyIndex].isEdited = true
    this.setState({mappingProperties})
  }

  public getMenuItemTemplate = (o:any) => {
    return (<div><span>{o.label}</span>
    {(o.value !== o.customId) && (<span>*</span>)}
    </div>)
  }

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll">
            <div className="layout-container">
              <SubmitHeader
                name={CONSTANTS.MODULE_INSTRUMENT}
                link="manageinstrument/instrument"
                isEdit={this.state.instrumentFormData?.isEditMode}
                onSaveClick={this.onSubmitAction}
                onCreateClick={this.onSubmitAction}
                onCancelClick={this.onCancelClick}
                onManualClick={this.onManualClick}
                showCreateManually={true}
                isEditMode={this.state.instrumentFormData?.isEditMode}
                isCreatedManually={
                  this.state.instrumentFormData?.isCreatedManually
                }
                manualLabel="Enter Manually"
                isLoading={this.state.formLoading}
              />
              <div className="d-block mt-3">
                <div className="col-6 no-padding float-left">
                  <div className="box-1 h-100">
                    <div className="box-circle">
                      <p className="box-circle-text"> 1 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.CONNECTION_DETAILS)}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    <div className="row mt-4">
                      <div className="col-sm-7 col-md-7">
                        <Dropdown
                          label={t(
                            CONSTANTS.NETWORK + " " + CONSTANTS.CONNECTION_TYPE
                          )}
                          allowAdd={true}
                          clearable={false}
                          required={true}
                          placeholder={t(
                            CONSTANTS.LABEL_PICK +
                              " " +
                              CONSTANTS.NETWORK +
                              " " +
                              CONSTANTS.CONNECTION_TYPE
                          )}
                          searchable={true}
                          value={this.state.networkSelectedType}
                          onChange={this.networkConnectionChangehandler}
                        >
                          {this.state.networkConnectionsList.map((o) => (
                            <DropdownOption
                              key={o.value}
                              label={o.label}
                              value={o.value}
                            />
                          ))}
                        </Dropdown>
                      </div>

                      <div className="col-sm-4 col-md-4 mt-4">
                        <div className="auto-checkbox form-check mt-2">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="exampleCheck1"
                            checked={this.state.connectFormData?.isAutoLine}
                            onKeyUp={(e)=>this.openAutoLineIns()}
                            onChange={(e)=>this.openAutoLineIns()}
                          />
                          <label
                            className="form-check-label autoline-label"
                            htmlFor="exampleCheck1"
                          >
                            {t(CONSTANTS.LABLE_AUTOLINE_FILES)}
                          </label>
                        </div>
                      </div>
                    </div>

                    {this.state.isIp ? (
                      <div className="row mt-2">
                        <div className="col-sm-3 col-md-3">
                          <Input
                            inputAttributes={{ autoFocus: "true" }}
                            dataType="text"
                            placeholder="000.000.000.000"
                            label={t(CONSTANTS.LABLE_INSTRUMENT_IP)}
                            required={true}
                            className={
                              this.state.ipError || this.state.isDuplicateIp
                                ? "error-code"
                                : ""
                            }
                            value={this.state.connectFormData.ipAddress}
                            onValueChange={this.setIpAddress}
                            onLostFocus={() =>
                              this.checkDuplicateIPandPort(true)
                            }
                            maxLength={15}
                            showValidationBarWhenInvalid={
                              this.state.ipError || this.state.isDuplicateIp
                            }
                            description={
                              this.state.ipError &&
                              t(CONSTANTS.IP_VALIDATION_ERROR)
                            }
                          />
                        </div>

                        <div className="col-sm-3 col-md-3">
                          <Input
                            dataType="number"
                            placeholder="Port"
                            label={t(CONSTANTS.LABLE_PORT)}
                            required={true}
                            className={
                              this.state.portError ? "error-code w-50" : "w-50"
                            }
                            value={String(this.state.connectFormData.port)}
                            onValueChange={this.setPort}
                            maxLength={4}
                            showValidationBarWhenInvalid={this.state.portError}
                            description={
                              this.state.portError &&
                              t(CONSTANTS.PORT_VALIDATION_ERROR)
                            }
                          />
                        </div>
                      </div>
                    ) : null}

                    <div className={!this.state.isIp ? "row" : "row mt-2"}>
                      <div className="col-sm-5 col-md-5">
                        <Input
                          inputAttributes={{ autoFocus: "true" }}
                          dataType="text"
                          placeholder={t(CONSTANTS.LABLE_INSTRUMENT_USERNAME)}
                          label={t(CONSTANTS.LABLE_INSTRUMENT_USERNAME)}
                          required={true}
                          className={
                            this.state.usernameError
                              ? "error-code mt-2"
                              : "mt-2"
                          }
                          value={this.state.connectFormData.username}
                          onValueChange={this.setUserName}
                          maxLength={100}
                          showValidationBarWhenInvalid={
                            this.state.usernameError
                          }
                          description={
                            this.state.usernameError
                              ? this.state.connectFormData.username.length
                                ? t(CONSTANTS.USERNAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                      <div className="col-sm-5 col-md-5">
                        <Input
                          dataType={
                            this.state.isRevelPassword ? "text" : "password"
                          }
                          label={t(CONSTANTS.LABLE_INSTRUMENT_PASSWORD)}
                          placeholder={t(CONSTANTS.LABLE_INSTRUMENT_PASSWORD)}
                          value={this.state.connectFormData.password}
                          required={true}
                          onValueChange={this.setPassword}
                          className={
                            this.state.passwordError
                              ? "error-code mt-2 w-100"
                              : "mt-2 w-100"
                          }
                          maxLength={50}
                          icon={
                            this.state.isRevelPassword ? ABB_VIEW : ABB_HIDE
                          }
                          onIconClick={this.togglePassword}
                          showValidationBarWhenInvalid={
                            this.state.passwordError
                          }
                          description={
                            this.state.passwordError
                              ? this.state.connectFormData.password.length
                                ? t(CONSTANTS.PASSWORD_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    {this.state.instrumentFormData?.isCreatedManually ? (
                      <div className="row mt-3">
                        <div className="col-sm-6 col-md-5">
                          <Input
                            dataType="text"
                            required={true}
                            label={t(CONSTANTS.ENTER_XML_FILE)}
                            placeholder={t(CONSTANTS.ENTER_XML_FILE)}
                            value={this.state.connectFormData.dir}
                            onValueChange={this.setDirectory}
                            className={
                              this.state.dirError ? "error-code mt-2" : "mt-2"
                            }
                            resizable={false}
                            showValidationBarWhenInvalid={this.state.dirError}
                            description={
                              this.state.dirError &&
                              t(CONSTANTS.DIR_VALIDATION_ERROR)
                            }
                          />
                        </div>
                        <div className="col-sm-4 col-md-4">
                          <Input
                            dataType="text"
                            required={true}
                            label={t(CONSTANTS.ENTER_FILE_NAME)}
                            placeholder={t(CONSTANTS.ENTER_FILE_NAME)}
                            value={this.state.connectFormData.path}
                            onValueChange={this.setpath}
                            className={
                              this.state.pathError
                                ? "error-code mt-2 w-75"
                                : "mt-2 w-75"
                            }
                            resizable={false}
                            showValidationBarWhenInvalid={this.state.pathError}
                            description={
                              this.state.pathError &&
                              t(CONSTANTS.FILENAME_VALIDATION_ERROR)
                            }
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="mt-3">
                        <div className="font-xml">
                          <span className="ml-2">
                            {t(CONSTANTS.SELECT_XML_FILE)}
                          </span>
                          <span style={{ color: "#f03040" }}>
                            {t(CONSTANTS.REQUIRED)}
                          </span>
                        </div>
                        <div className="row browse-box mt-1">
                          <div className="col-sm-8 col-md-8 mt-3 ml-1">
                            <Input
                              dataType="text"
                              placeholder={
                                this.state.isIp
                                  ? t(CONSTANTS.SELECT_XML_FILE)
                                  : t(CONSTANTS.SELECT_XML_PLACEHOLDER)
                              }
                              value={this.state.connectFormData.dir}
                              disabled={this.state.isIp ? true : false}
                              onValueChange={this.setDirectory}
                              onLostFocus={() =>
                                this.checkDuplicateIPandPort(false)
                              }
                              className={
                                this.state.dirError ? "error-code mt-2" : "mt-2"
                              }
                              resizable={false}
                              showValidationBarWhenInvalid={this.state.dirError}
                              description={
                                this.state.dirError &&
                                t(CONSTANTS.DIR_VALIDATION_ERROR)
                              }
                            />
                          </div>
                          <div className="col-sm-3 col-md-3 mt-3 ml-1">
                            <Button
                              type="normal"
                              disabled={this.state.browseDisabled}
                              onClick={this.onBrowseClick}
                              text={
                                this.state.isFetch
                                  ? t(CONSTANTS.FETCH_FILE)
                                  : t(CONSTANTS.BROWSE_FILE)
                              }
                              className="mt-1"
                              style={{ background: "black", color: "white" }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row mt-3">
                      <div className="col-sm-4 col-md-6">
                        <Input
                          dataType="number"
                          label={t(CONSTANTS.POLL_FRQ_SEC)}
                          placeholder={t(CONSTANTS.POLL_FRQ)}
                          required={true}
                          value={String(
                            this.state.connectFormData.pollingFrequency
                          )}
                          onValueChange={this.setPollingFrequency}
                          className={"mt-2 input-type-width"}
                          maxLength={2}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 no-padding float-left">
                  <div className="box-2 h-100 ml-3">
                    <div className="box-circle">
                      <p className="box-circle-text"> 2 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.LABLE_ADDITIONAL_INFORMATION)}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    <div className="row mt-3">
                      <div className="col-sm-4 col-md-4">
                        <Input
                          dataType="text"
                          label={t(CONSTANTS.LABLE_INSTRUMENT_CODE)}
                          placeholder={t(CONSTANTS.LABLE_INSTRUMENT_CODE)}
                          required={true}
                          value={this.state.instrumentFormData?.codeId}
                          onValueChange={this.setCodeId}
                          className={
                            this.state.codeError ? "error-code mt-2" : "mt-2"
                          }
                          maxLength={20}
                          showValidationBarWhenInvalid={this.state.codeError}
                          description={
                            this.state.codeError
                              ? this.state.instrumentFormData.codeId.length
                                ? t(CONSTANTS.INSTRUMENT_CODE_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                      <div className="col-sm-4 col-md-4">
                        <Input
                          dataType="text"
                          label={t(CONSTANTS.LABLE_NAME)}
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          value={this.state.instrumentFormData?.name}
                          onValueChange={this.setName}
                          className={
                            this.state.nameError ? "error-code mt-2" : "mt-2"
                          }
                          maxLength={250}
                          showValidationBarWhenInvalid={this.state.nameError}
                          description={
                            this.state.nameError
                              ? this.state.instrumentFormData.name.length
                                ? t(CONSTANTS.INSTRUMENT_NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                      <div className="col-sm-4 col-md-4">
                        <div className="multi-mode-text">
                          <b>
                            {this.state.multimodeInstrument
                              .isMultimodeInstrument &&
                            !this.state.multimodeInstrument
                              .showMultimodeInstrumentDialog
                              ? t(CONSTANTS.NOTE) + ": "
                              : ""}
                          </b>
                          {this.state.multimodeInstrument
                            .isMultimodeInstrument &&
                          !this.state.multimodeInstrument
                            .showMultimodeInstrumentDialog
                            ? t(CONSTANTS.LABEL_MULTIMODE_INSTRUMENT_TEXT)
                            : ""}
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-sm-8 col-md-8">
                        <Dropdown
                          label={t(
                            CONSTANTS.LABEL_SELECT +
                              " " +
                              CONSTANTS.MODULE_INSTRUMENTTYPE
                          )}
                          allowAdd={true}
                          multiselect={false}
                          required={true}
                          clearable={false}
                          placeholder={
                            t(CONSTANTS.LABEL_PICK) +
                            " " +
                            t(CONSTANTS.MODULE_INSTRUMENTTYPE)
                          }
                          searchable={true}
                          value={this.state.selectedType}
                          onChange={this.typeChangeHandler}
                          createOptionText={t("Create")}
                        >
                          {this.state.instrumentTypeList.map((o) => (
                            <DropdownOption
                              key={o.value}
                              label={o.label}
                              value={o.value}
                            />
                          ))}
                        </Dropdown>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-sm-8 col-md-8">
                        <Dropdown
                          disabled={
                            this.state.connectFormData.isAutoLine ? true : false
                          }
                          label={t(CONSTANTS.LABLE_INSTRUMENT_DIRECTIONS)}
                          required={true}
                          multiselect={true}
                          clearable={true}
                          placeholder={
                            t(CONSTANTS.LABEL_PICK) +
                            " " +
                            t(CONSTANTS.LABEL_DIRECTIONS)
                          }
                          searchable={true}
                          value={this.state.selectedDirections}
                          onChange={this.directionChangehandler}
                        >
                          {this.state.directionsList.map((o) => (
                            <DropdownOption
                              key={o.value}
                              label={o.label}
                              value={o.value}
                              disabled={o.disabled}
                            />
                          ))}
                        </Dropdown>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          dataType="text"
                          label={t(CONSTANTS.SERIAL_NO)}
                          placeholder={t(CONSTANTS.SERIAL_NO)}
                          // required={true}
                          value={this.state.instrumentFormData?.serialNumber}
                          onValueChange={this.setSerialNumber}
                          className={
                            this.state.serialNoError
                              ? "error-code mt-2 w-25"
                              : "mt-2 w-25"
                          }
                          maxLength={20}
                          showValidationBarWhenInvalid={
                            this.state.serialNoError
                          }
                          description={
                            this.state.serialNoError
                              ? this.state.instrumentFormData.serialNumber
                                  .length
                                ? t(CONSTANTS.SERIAL_NO_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          className="mt-2 h-25"
                          dataType="textarea"
                          label={t(CONSTANTS.LABEL_DESCRIPTION)}
                          placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                          value={this.state.instrumentFormData?.description}
                          onValueChange={this.setDescription}
                          inputAttributes={{ rows: "4" }}
                          resizable={false}
                          maxLength={200}
                        />
                      </div>
                    </div>
                    <div className="p-3">
                      {200 - this.state.instrumentFormData.description.length}{" "}
                      {t("character left out of 200 character")}
                    </div>
                  </div>
                </div>
              </div>
              {this.state.instrumentFormData?.isCreatedManually ? (
                <ManualProperties
                  onAddPropertyClick={this.onManualAddPropertyClick}
                >
                  {this.state.mappingProperties.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="text-center">
                        {t(this._noPropertyMapped)}
                      </td>
                    </tr>
                  ) : (
                    this.state.mappingProperties.map((property, index) => (
                      <tr key={index}>
                        <td>
                          <Input
                            className={
                              property.isError
                                ? "error-code border-error"
                                : ""
                            }
                            dataType="number"
                            style={{ width: 60 }}
                            indicateChanged={false}
                            value={String(property.customId)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setCustomId(value, index)
                            }
                            showValidationBarWhenInvalid={
                              property.isError
                            }
                            onLostFocus={() => this.onBlur(index)}
                            description={
                              property.isError ?
                              t(CONSTANTS.CUSTOMID_VALIDATION_ERROR) : ""
                            }
                          />
                        </td>
                        <td>
                          <Dropdown
                            allowAdd={true}
                            style={{ width: 190 }}
                            clearable={true}
                            placeholder={t(
                              CONSTANTS.LABEL_PICK +
                                " " +
                                CONSTANTS.MODULE_PROPERTY
                            )}
                            searchable={true}
                            value={property.selectedProperty}
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={(value) =>
                              this.onPropertySelection(value, index)
                            }
                          >
                            {this.state.propertiesAvailableForMapping.map(
                              (o) => (
                                <DropdownOption
                                  key={o.value}
                                  label={o.label}
                                  value={o.value}
                                />
                              )
                            )}
                          </Dropdown>
                        </td>
                        <td>
                          <Input
                            dataType="text"
                            style={{ width: 90 }}
                            value={String(property.instrumentPropertyId)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setInstrumentPropertyId(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                        <td>
                          <Input
                            dataType="text"
                            style={{ width: 120 }}
                            value={String(property.instrumentPropertyName)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setInstrumentPropertyName(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                        <td>
                          <Dropdown
                            allowAdd={false}
                            style={{ width: 210 }}
                            clearable={false}
                            placeholder={
                              t(CONSTANTS.LABEL_PICK) +
                              " " +
                              t(CONSTANTS.LABLE_INSTRUMENT_DIRECTIONS)
                            }
                            searchable={false}
                            multiselect={true}
                            value={property.selectedDirection}
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={(value) =>
                              this.onDirectionSelection(value, index)
                            }
                          >
                            {this.state.selectedDirections.map((o) => (
                              <DropdownOption
                                key={o.value}
                                label={o.label}
                                value={o.value}
                              />
                            ))}
                          </Dropdown>
                        </td>
                        <td>
                          <Input
                            dataType="text"
                            style={{ width: 60 }}
                            value={String(property.unit)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setUnit(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                        <td>
                          <Input
                            dataType="number"
                            style={{ width: 60 }}
                            value={String(property.decimals)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setDecimal(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                        <td>
                          <Input
                            dataType="number"
                            style={{ width: 90 }}
                            value={String(property.min)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setMin(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                        <td>
                          <Input
                            dataType="number"
                            style={{ width: 90 }}
                            value={String(property.max)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setMax(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                        <td
                          className="delete-icon deleted-last-col"
                          key={index}
                        >
                          <Icon
                            style={{ width: 30 }}
                            onClick={() => this.deleteProperty(index)}
                            name="abb/minus-in-circle"
                            sizeClass="medium"
                            color="blue"
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </ManualProperties>
              ) : this.state.fetchedProperties.length > 0 ? (
                <BrowseProperty
                  inderminateValue={this.state.fetchedIndeterminate}
                  onAllPropertyChecked={this.onAllPropertyChecked}
                  onPropertyChecked={this.onPropertyChecked}
                  fetchedProperties={this.state.fetchedProperties}
                  onArrowClick={this.onArrowClick}
                  mappingProperties={this.state.mappingProperties}
                >
                  {this.state.mappingProperties.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center">
                        {t(this._noPropertyMapped)}
                      </td>
                    </tr>
                  ) : (
                    this.state.mappingProperties.map((property, index) => (
                      <tr key={index}>
                        <td>
                          <Input
                            className={
                              property.isError
                                ? "error-code border-error"
                                : ""
                            }
                            dataType="number"
                            style={{ width: 60 }}
                            indicateChanged={false}
                            value={String(property.customId)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setCustomId(value, index)
                            }
                            showValidationBarWhenInvalid={
                              property.isError
                            }
                            onLostFocus={() => this.onBlur(index)}
                            description={
                              property.isError ?
                              t(CONSTANTS.CUSTOMID_VALIDATION_ERROR) : ""
                            }
                          />
                        </td>
                        <td>
                          <Dropdown
                            style={{ width: 190 }}
                            allowAdd={true}
                            clearable={true}
                            placeholder={t(
                              CONSTANTS.LABEL_PICK +
                                " " +
                                CONSTANTS.MODULE_PROPERTY
                            )}
                            searchable={true}
                            value={property.selectedProperty}
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={(value) =>
                              this.onPropertySelection(value, index)
                            }
                          >
                            {this.state?.propertiesAvailableForMapping?.map(
                              (o) => (
                                <DropdownOption
                                  key={o.value}
                                  label={o.label}
                                  value={o.value}
                                  menuItemTemplate={this.getMenuItemTemplate(o)}
                                />
                              )
                            )}
                          </Dropdown>
                        </td>
                        <td style={{ minWidth: 150 }}>
                          {property.instrumentPropertyName}
                        </td>
                        <td className="mapping-direction-dropdown">
                          <Dropdown
                            style={{ width: 210 }}
                            allowAdd={false}
                            clearable={false}
                            placeholder={
                              t(CONSTANTS.LABEL_PICK) +
                              " " +
                              t(CONSTANTS.LABLE_INSTRUMENT_DIRECTIONS)
                            }
                            searchable={true}
                            multiselect={true}
                            disabled={this.state.connectFormData?.isAutoLine}
                            value={property.selectedDirection}
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={(value) =>
                              this.onDirectionSelection(value, index)
                            }
                          >
                            {this.state.selectedDirections?.map((o) => (
                              <DropdownOption
                                key={o.value}
                                label={o.label}
                                value={o.value}
                              />
                            ))}
                          </Dropdown>
                        </td>
                        <td>
                          <Input
                            dataType="text"
                            style={{ width: 60 }}
                            value={String(property.unit)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setUnit(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                        <td>
                          <Input
                            dataType="number"
                            style={{ width: 60 }}
                            value={String(property.decimals)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value: string) =>
                              this.setDecimal(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                        <td>
                          <Input
                            dataType="number"
                            style={{ width: 60 }}
                            value={String(property.min)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value?: string) =>
                              this.setMin(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                        <td>
                          <Input
                            dataType="number"
                            style={{ width: 60 }}
                            value={String(property.max)}
                            // tslint:disable-next-line: jsx-no-lambda
                            onValueChange={(value?: string) =>
                              this.setMax(value, index)
                            }
                            onLostFocus={() => this.onBlur(index)}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </BrowseProperty>
              ) : (
                this.state.connectFormData.dir && (
                  <div>
                    <NoDataFound
                      moduleName={t(CONSTANTS.MODULE_INSTRUMENT)}
                      message={t(CONSTANTS.NO_PROPERTIES_MESSAGE)}
                    />
                  </div>
                )
              )}
            </div>

            {this.state.instrumentFormData?.isEditMode && (
              <Dialog
                isOpen={this.state.clearMappingOnDirectionChange}
                // tslint:disable-next-line: jsx-no-lambda
                onClose={() => {
                  this.setState({
                    clearMappingOnDirectionChange: false,
                    selectedDirections: this._directions,
                  });
                }}
                showCloseButton={true}
                closeOnEscape={false}
                closeOnLostFocus={false}
                dimBackground={true}
                title={t(CONSTANTS.LABEL_DIRECTION_CHANGE)}
                standardButtonsOnBottom={[
                  {
                    text: t(CONSTANTS.BUTTON_CANCEL),
                    type: "discreet-blue",
                    handler: (dlg) => dlg.close(),
                  },
                  {
                    text: t(CONSTANTS.BUTTON_OK),
                    type: "primary-blue",
                    handler: this.performDirectionChange,
                  },
                ]}
              >
                <div>
                  {t(CONSTANTS.DIRECTION_CHANGE_MAPPING_MESSAGE)}
                  <br />
                  <br />
                  <b>{t(CONSTANTS.NOTE)}:</b>{" "}
                  {t(CONSTANTS.MAPPING_LOST_MESSAGE)}
                </div>
              </Dialog>
            )}

            <Dialog
              isOpen={this.state.isInstrumentConnected}
              containerClassName="dialog-container"
              onClose={this.onCloseDialog}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.LIST_DIRECTORIES)}
            >
              <div className="row">
                <div className="col-6">
                  <div style={{ background: "#d3d3d3" }}>
                    <p className="sidebar-main-title p-2">
                      {t(CONSTANTS.LIST_DIRECTORIES)}
                    </p>
                  </div>
                  <div className="browse-list-height overflow-auto">
                    <ul className="list-group list-group-flush">
                      {this.state.dirItems.map((dir, index) => {
                        return dir.split(".").pop() === "xml" ||
                          dir.split(".").pop() === "XML" ? (
                          <li
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick={() => this.fetchProperties(dir)}
                            className="list-group-item directory"
                            style={{ background: "#f5f5f5" }}
                            key={index}
                          >
                            {dir}
                          </li>
                        ) : (
                          <li
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick={() => this.fetchFiles(dir, true, true)}
                            className="list-group-item directory"
                            style={{ background: "#f5f5f5" }}
                            key={index}
                          >
                            {dir}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-6">
                  <div style={{ background: "#d3d3d3" }}>
                    <p className="sidebar-main-title p-2">
                      {t(CONSTANTS.LIST_FILES)}
                    </p>
                  </div>
                  <div className="browse-list-height overflow-auto">
                    <ul className="list-group directory list-group-flush">
                      {this.state.fileItems.map((file) => (
                        <li
                          onClick={() => this.fetchProperties(file)}
                          className="list-group-item directory"
                          style={{ background: "#f5f5f5" }}
                          key={file}
                          value={file}
                        >
                          {file}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </Dialog>
            <Dialog
              isOpen={this.state.clearMappingOnInstrumentTypeChange}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() =>
                this.setState({ clearMappingOnInstrumentTypeChange: false })
              }
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.LABEL_INSTRUMENT_TYPE_CHANGE)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: this.onCloseIntrumentTypeChange,
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.performTypeChange,
                },
              ]}
            >
              <div>
                {t(CONSTANTS.INSTRUMENT_TYPE_CHANGE_MAPPING_MESSAGE)}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.MAPPING_LOST_MESSAGE)}
              </div>
            </Dialog>
            {/* Multi mode instrument creation Popup */}
            <Dialog
              isOpen={
                this.state.multimodeInstrument.showMultimodeInstrumentDialog &&
                !this.state.instrumentFormData.isEditMode
              }
              onClose={() =>
                this.setState({
                  multimodeInstrument: {
                    showMultimodeInstrumentDialog: false,
                    isMultimodeInstrument: false,
                    message: this.state.multimodeInstrument.message,
                  },
                })
              }
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.LABEL_MULTIMODE_INSTRUMENT)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => this.duplicateIpDialogCancelClick(dlg),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.duplicateIpDialogOkClick,
                },
              ]}
            >
              <div>
                {t(
                  CONSTANTS.LABEL_MULTIMODE_INSTRUMENT_CONFIRM.format(
                    this.state.instrumentFormData.isEditMode
                      ? CONSTANTS.LABEL_UPDATE
                      : CONSTANTS.LABEL_CREATE
                  )
                )}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b>
                {this.state.connectFormData?.ipAddress?.length
                  ? t(
                      CONSTANTS.LABEL_MULTIMODE_INSTRUMENT_MESSAGE).format(
                        this.state.multimodeInstrument.message,
                        this.state.connectFormData.ipAddress
                      )
                  : t(
                      CONSTANTS.LABEL_MULTIMODE_INSTRUMENT_MESSAGE).format(
                        this.state.multimodeInstrument.message,
                        this.state.connectFormData.dir
                      )
                    }
              </div>
            </Dialog>
            <Dialog
              isOpen={this.state.openAuoLineDialog}
              onClose={() => this.setState({ openAuoLineDialog: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.PROPERTY_DETAILS_WILL_BE_RESET)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.setAutoLine,
                },
              ]}
            />
              <Dialog
                isOpen={this.state.isPropertyInUse && !this.state.mappingProperties[this.state.mappingPropertyIndex]?.isEdited}
                onClose={() => this.setState({ isPropertyInUse: false })}
                showCloseButton={true}
                closeOnEscape={false}
                closeOnLostFocus={false}
                dimBackground={true}
                title={t(CONSTANTS.LABEL_EDIT_PROPERTY_IN_USE)}
                standardButtonsOnBottom={[
                  {
                    text: t(CONSTANTS.BUTTON_CANCEL),
                    type: "discreet-blue",
                    handler: () => this.onCancel(),
                  },
                  {
                    text: t(CONSTANTS.BUTTON_OK),
                    type: "primary-blue",
                    handler: () => this.onConfirm(),
                  },
                ]}
              >
                <div>
                  {t(CONSTANTS.LABEL_EDIT_PROPERTY_IN_USE_CONFIRM_TEXT1)}
                  <br />
                  <br />
                  {t(CONSTANTS.LABEL_EDIT_PROPERTY_IN_USE_CONFIRM_TEXT2)}
                </div>
              </Dialog>
          </div>
        )}
      </Translation>
    );
  }

  private setInstrumentPropertyName(value: any, index: number) {
    const mappingProperties = this.state.mappingProperties;
    mappingProperties[index].instrumentPropertyName = value;

    this.setState(
      {
        mappingProperties,
      },
      this.validate
    );
  }

  private setInstrumentPropertyId(value: any, index: number) {
    const mappingProperties = this.state.mappingProperties;
    mappingProperties[index].instrumentPropertyId = value;

    this.setState(
      {
        mappingProperties,
      },
      this.validate
    );
  }

  private onDirectionSelection(value: any, index: number) {
    const mappingProperties = this.state.mappingProperties;
    mappingProperties[index].selectedDirection = value;
    let dirData: any[] = [];
    value.map((dir: any) => {
      dirData.push(new DirectionData(dir.value, dir.label, dir.order));
    });
    mappingProperties[index].direction = dirData;
    this.setState(
      {
        mappingProperties,
      },
      () => {
        this.validate(),
        this.onBlur(index)
      }
    );
  }
  private getFirstOrDefaultDirection(): any[] {
    let dirData: any[] = [];
    if (this.state.selectedDirections.length === 1) {
      this.state.selectedDirections.map((dir: any) => {
        dirData.push(new DirectionData(dir.value, dir.label, dir.order));
      });
    }
    return dirData;
  }
  private setFirstOrDefaultDirection(property: IInstrumentProperty) {
    if (this.state.selectedDirections.length === 1) {
      property.direction = this.getFirstOrDefaultDirection();
      property.selectedDirection = [this.state.selectedDirections[0]];
    }
  }

  private onPropertySelection(value: any, index: number) {
    const mappingProperties = this.state.mappingProperties;
    mappingProperties[index].selectedProperty = value;
    mappingProperties[index].isError = false;
    if (value.length !== 0) {
      if (value[0].isNew) {
        this.resetMappingProperty(mappingProperties, index, true);
        mappingProperties[index].name = value[0].label;
        this.setFirstOrDefaultDirection(mappingProperties[index]);
      } else {
        const property = this.state.selectedInstrumentType.properties.find(
          (d) => d.id === value[0].value
        );
        const availableProperty = this.state.propertiesAvailableForMapping.find((
          (d) => d.value === value[0].value
        ))
        mappingProperties[index].isNew = false;
        if(property){
        mappingProperties[index].id = property.id ? property.id : CONSTANTS.DefaultGuid;
        mappingProperties[index].customId = property.customId;
        mappingProperties[index].name = property.name;
        mappingProperties[index].decimals = property.decimal;
        } else if(availableProperty){
          mappingProperties[index].id =  availableProperty.id ? availableProperty.id : CONSTANTS.DefaultGuid;
          mappingProperties[index].customId = availableProperty.value;
          mappingProperties[index].name = availableProperty.label;
          mappingProperties[index].decimals = availableProperty.decimal;
        }
        if (this.state.instrumentFormData.isCreatedManually)
          mappingProperties[index].unit = property.unit ? property.unit : "";

        this._newMappingProperties = JSON.stringify(mappingProperties)
      }
    } else {
      this.resetMappingProperty(mappingProperties, index, false);
    }
    this.setState(
      {
        mappingProperties,
      },
      () => {
        this.validate()
        if(value.length !== 0 && value[0].isNew){
          this.onBlur(index)
        }
      }
    );
  }

  private resetMappingProperty(
    mappingProperties: IInstrumentProperty[],
    index: number,
    isNew: boolean
  ) {
    mappingProperties[index].isNew = isNew;
    if (!mappingProperties[index].direction) {
      mappingProperties[index].direction.push(defaultDirectionData);
    }
    this.state?.selectedInstrumentType?.properties?.forEach((item) => {
      if (mappingProperties[index].customId === item.customId) {
      }
    });
    if(!this.state.instrumentFormData.isEditMode){
      mappingProperties[index].min = "";
      mappingProperties[index].max = "";
      mappingProperties[index].selectedDirection = [];
    }
  }

  private setCustomId(value: string, index: number) {
    const mappingProperties = this.state.mappingProperties;
    const refProp = this._duplicateMappingProperties ? JSON.parse(this._duplicateMappingProperties) : []
    let currentCustomId
    let instrumentTypeCustomId
    currentCustomId = refProp[index]?.customId?.toString()
    if(mappingProperties[index].id !== CONSTANTS.DefaultGuid && this.state.instrumentFormData.isEditMode){
      mappingProperties[index].id = refProp[index]?.id
    }
    const filteredInstrumentType = this.state.selectedInstrumentType?.properties?.filter((i:any) => i.customId === Number(value))
    if(filteredInstrumentType.length !== 0 && filteredInstrumentType[0]?.customId === Number(value)){
      mappingProperties[index].id = filteredInstrumentType[0]?.id
      instrumentTypeCustomId = filteredInstrumentType[0]?.customId?.toString()
    }
    
    mappingProperties[index].customId = Number(value);
    const filteredData = this._propertyData?.filter((x:any) => mappingProperties[index].customId === x.id)
    if(filteredData?.length !== 0 &&  value !== currentCustomId && value !== instrumentTypeCustomId){
      mappingProperties[index].isError = true
      this.setState({
        customIdError: true,
        mappingProperties
      }, this.validate)
    } else{
      mappingProperties[index].isError = false
      this.setState({
        customIdError: false,
        mappingProperties
      }, this.validate)
    }
  }

  private setMin(value: string, index: number) {
    const mappingProperties = this.state.mappingProperties;
    mappingProperties[index].min = value;
    this.setState(
      {
        mappingProperties,
      },
      this.validate
    );
  }

  private setMax(value: string, index: number) {
    const mappingProperties = this.state.mappingProperties;
    mappingProperties[index].max = value;
    this.setState(
      {
        mappingProperties,
      },
      this.validate
    );
  }

  private setUnit(value: string, index: number) {
    const mappingProperties = this.state.mappingProperties;
    mappingProperties[index].unit = value;
    this.setState(
      {
        mappingProperties,
      },
      this.validate
    );
  }

  private setDecimal(value: string, index: number) {
    const mappingProperties = this.state.mappingProperties;
    mappingProperties[index].decimals = Number(value);
    this.setState(
      {
        mappingProperties,
      },
      this.validate
    );
  }

  private onAllPropertyChecked = (value: any) => {
    if (this.validateMapping()) {
      const fetchedProperties = this.state.fetchedProperties;
      let fetchedIndeterminate = ThreeStateValue.Unchecked;
      if (
        this.state.fetchedIndeterminate === ThreeStateValue.Indeterminate ||
        this.state.fetchedIndeterminate === ThreeStateValue.Unchecked
      ) {
        fetchedProperties.forEach((property) => {
          property.isSelected = true;
        });
        fetchedIndeterminate = ThreeStateValue.Checked;
      } else {
        fetchedProperties.forEach((property) => {
          property.isSelected = false;
        });
        fetchedIndeterminate = ThreeStateValue.Unchecked;
      }
      this.setState(
        {
          fetchedProperties,
          fetchedIndeterminate,
        },
        () => {
          const rowsToAddOrRemove = fetchedProperties.filter(
            (d) => d.isSelected
          );
          if (rowsToAddOrRemove.length > 0) {
            this.addRows(rowsToAddOrRemove);
          } else {
            // TODO: Show confirmation before clearing the mapping
            this.removeRows();
          }
        }
      );
    }
  };

  private validateMapping(): boolean {
    if (this.state.selectedInstrumentType === undefined) {
      triggerNotifications.error("No instrument type selected.").then();
      return false;
    } else if (this.state.selectedDirections.length === 0) {
      triggerNotifications.error("No directions selected.").then();
      return false;
    }
    return true;
  }

  private onArrowClick = () => {
    const mappingProperty: any = [];
    const propertiesToMap: any = [];
    const objectToMap: any = {};

    this.state.propertiesAvailableForMapping.forEach((element: any) => {
      objectToMap[element.customId] = element;
    });

    this.state.mappingProperties.forEach((item: any) => {
      if (!item.selectedDirection) {
        item.selectedDirection = [];
      }

      if (objectToMap[item.uniqueId]) {
        // Property exist on Dropdown selection
        item.selectedProperty = [
          {
            value: objectToMap[item.uniqueId].value,
            label: objectToMap[item.uniqueId].label,
          },
        ];
        propertiesToMap.push(objectToMap[item.uniqueId]);
      } else {
        // Property doesnot exist on Dropdown selection
        if (!item.isDisabled) {
          item.selectedProperty = [
            {
              value: item.instrumentPropertyId,
              label: item.instrumentPropertyName,
              uniqueId: item.uniqueId,
              decimal: item.decimals,
              customId: item.instrumentPropertyId,
            },
          ];
          const propertiesToPush = this.state.propertiesAvailableForMapping.map((i:any) => {
            if(i.label !== item.instrumentPropertyName && i.customId !== item.instrumentPropertyId){
              return true
            } else{
              return false
            }
          })
          if(propertiesToPush){
            propertiesToMap.push({
              value: item.instrumentPropertyId,
              label: item.instrumentPropertyName,
              uniqueId: item.uniqueId,
              decimal: item.decimals,
              customId: item.instrumentPropertyId,
            });
          }
        }
      }

      if (!item.isDisabled) {
        if (this.state.selectedInstrumentType.properties.length) {
          // DROPDOWN SELECTION - When you create instrument type by selecting the dropdown
          const objectToLookup: any = {};
          this.state.selectedInstrumentType.properties.forEach((element) => {
            objectToLookup[element.customId] = element;
          });
          if (objectToLookup[item.instrumentPropertyId]) {
            item.isNew = false;
            item.id = item.uniqueId ? objectToLookup[item.instrumentPropertyId].id : CONSTANTS.DefaultGuid;
            item.name = objectToLookup[item.instrumentPropertyId].name;
            item.decimals = objectToLookup[item.instrumentPropertyId].decimal;
            item.unit = this.state.instrumentFormData.isCreatedManually
              ? objectToLookup[item.instrumentPropertyId].unit
              : "";
            item.customId = Number(
              objectToLookup[item.instrumentPropertyId].customId
            )
              ? Number(objectToLookup[item.instrumentPropertyId].customId)
              : Number(item.instrumentPropertyId);
          } else {
            item.customId = Number(item.instrumentPropertyId);
            item.id = CONSTANTS.DefaultGuid;
            item.name = item.instrumentPropertyName;
          }
        } else {
          // CREATING BY ENTERING TEXT - When you create instrument type first time without selecting the dropdown
          if (this.state.instrumentFormData.isEditMode) {
            item.isNew = false;
          }
          // eslint-disable-next-line no-lone-blocks
          {
            item.isNew = true;
          }
          item.id = CONSTANTS.DefaultGuid;
          item.name = item.instrumentPropertyName;
          item.customId = Number(item.instrumentPropertyId);
        }
      }
      if (!item.isDisabled) {
        this.state.propertiesAvailableForMapping.map((i:any) => {
          if(i.label === item.instrumentPropertyName && Number(i.customId) === Number(item.instrumentPropertyId)){
            item.isNew = false;
            item.id = i?.value;
            item.name = i?.label;
            item.decimals = i?.decimal;
            item.customId = i.customId
            item.selectedProperty = [
              {
                value: i.value,
                label: i.label,
                uniqueId: i.value,
                decimal: i?.decimal,
                customId: i.customId,
              },
            ]
          }
        })
      }
      mappingProperty.push(item);
    });

    const propertiesAvailableForMapping: any = [
      ...this.state.propertiesAvailableForMapping,
      ...propertiesToMap,
    ];
    const uniqpropertiesAvailableForMapping =
      propertiesAvailableForMapping.filter((obj: any, index: any) => {
        // Remove duplicate array of objects
        return (
          propertiesAvailableForMapping
            .map((obj: any) => Number(obj["customId"]))
            .indexOf(Number(obj["customId"])) === index
        );
      });
    this._newMappingProperties = JSON.stringify(mappingProperty)
    this.setState(
      {
        propertiesAvailableForMapping: uniqpropertiesAvailableForMapping,
        mappingProperties: mappingProperty,
        newPropertiesAddedForMapping: propertiesToMap
      },
      () => {
        this.forceUpdate();
        this.validate();
      }
    );
  };

  private onPropertyChecked = (property: IDeviceProperties, index: number) => {
    // Add Directions check also
    if (this.validateMapping()) {
      const fetchedProperties = this.state.fetchedProperties;
      fetchedProperties[index].isSelected = !property.isSelected;
      this.setState(
        {
          fetchedProperties,
        },
        () => {
          if (
            this.state.fetchedProperties.some((d) => d.isSelected) &&
            this.state.fetchedProperties.some((d) => !d.isSelected)
          ) {
            this.setState({
              fetchedIndeterminate: ThreeStateValue.Indeterminate,
            });
          } else if (this.state.fetchedProperties.some((d) => d.isSelected)) {
            this.setState({
              fetchedIndeterminate: ThreeStateValue.Checked,
            });
          } else {
            this.setState({
              fetchedIndeterminate: ThreeStateValue.Unchecked,
            });
          }
          const rowsToAddOrRemove = fetchedProperties.filter(
            (d) => d.isSelected
          );
          if (rowsToAddOrRemove.length > 0) {
            this.addRows(rowsToAddOrRemove);
          } else {
            this.removeRows();
          }
        }
      );
    }
  };

  private removeRows() {
    const mappingProperties: IInstrumentProperty[] = [];
    this.setState(
      {
        mappingProperties,
      },
      this.validate
    );
  }

  private addRows(fetchedProperties: IDeviceProperties[]) {
    const previousProperties = this.state.mappingProperties.filter((d) =>
      fetchedProperties.map((de) => de.id).includes(d.instrumentPropertyId)
    );
    const propertiesToBeAdded = fetchedProperties.filter(
      (d) =>
        !previousProperties.map((de) => de.instrumentPropertyId).includes(d.id)
    );

    const mappingProperties: IInstrumentProperty[] = previousProperties;

    propertiesToBeAdded.forEach((element) => {
      let direction = [defaultDirectionData];
      const item = new InstrumentProperty(
        element.uniqueId,
        "",
        element.id,
        element.name,
        direction,
        "",
        "",
        0,
        element.unit,
        2,
        "",
        false,
        new PropertyTypeData("", ""),
        element.uniqueId
      );
      this.setFirstOrDefaultDirection(item);
      if (mappingProperties.length - 1 < element.index) {
        mappingProperties.push(item);
      } else {
        mappingProperties.splice(element.index, 0, item);
      }
    });
    this.setState(
      {
        mappingProperties,
      },
      this.validate
    );
  }
}

export default withRouter(Form);
